/**
 * Load the libraries for the DITA topics pages.
 */
import './config.js';
import './nav-links/nav-links-loader.js';
import './search/searchAutocomplete.js';
import './core/webhelp.js';
import './search/search-init.js';
import './core/expand.js';
import './image-map/image-map.js';
import './template/template-module-loader.js';
